import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import PerfectScrollbar from 'react-perfect-scrollbar'

import MenuItem from './MenuItem'

import styles from '../../../main.module.scss'

const isPathActive = (pathname, path) =>
  path === '/'
    ? pathname === '/'
    : pathname === path || pathname.startsWith(`${path}/`)

const isMenuActive = (pathname, menu) =>
  menu.childs
    ? menu.childs.some((child) => isPathActive(pathname, child.path))
    : isPathActive(pathname, menu.path)

const SidebarMenu = ({ sidebarMenu }) => {
  const { pathname } = useLocation()
  const [expandedMenu, setExpandedMenu] = useState(() =>
    sidebarMenu
      .filter((menu) => menu.childs && isMenuActive(pathname, menu))
      .map((menu) => menu.key),
  )

  // Open the section of the current page, leave the others as they are
  useEffect(() => {
    const activeMenu = sidebarMenu.find(
      (menu) => menu.childs && isMenuActive(pathname, menu),
    )
    if (activeMenu) {
      setExpandedMenu((current) =>
        current.includes(activeMenu.key)
          ? current
          : [...current, activeMenu.key],
      )
    }
  }, [pathname, sidebarMenu])

  return (
    <div className={styles.menuWrapper}>
      <PerfectScrollbar>
        <div className={styles.menu}>
          <ul>
            {sidebarMenu.map((menu) => (
              <li
                key={menu.key}
                className={[
                  expandedMenu.includes(menu.key)
                    ? styles.expanded
                    : 'default-menu',
                  isMenuActive(pathname, menu) ? styles.active : '',
                ].join(' ')}
              >
                <MenuItem
                  menu={menu}
                  withIcon
                  expandedMenu={expandedMenu}
                  setExpandedMenu={setExpandedMenu}
                />
                {menu.childs && (
                  <ul>
                    {menu.childs.map((child) => (
                      <li
                        key={child.path}
                        className={
                          isPathActive(pathname, child.path)
                            ? styles.active
                            : ''
                        }
                      >
                        <MenuItem menu={child} withIcon={false} />
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
      </PerfectScrollbar>
    </div>
  )
}

export default SidebarMenu
